import { ChangeDetectionStrategy, Component } from "@angular/core";
import { RouterOutlet } from "@angular/router";

import { FooterComponent } from "../footer/footer.component";
import { TopNavComponent } from "../top-nav/top-nav.component";

@Component({
    selector: "app-single-layout",
    templateUrl: "./single-layout.component.html",
    styleUrls: ["./single-layout.component.scss"],
    changeDetection: ChangeDetectionStrategy.OnPush,
    imports: [TopNavComponent, FooterComponent, RouterOutlet]
})
export class SingleLayoutComponent {}
